import { render, staticRenderFns } from "./AppCopyBtn.vue?vue&type=template&id=30f6aa0f"
import script from "./AppCopyBtn.vue?vue&type=script&lang=js"
export * from "./AppCopyBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports